<template>
  <div class="scrollable indexDIV">
    <v-header></v-header>
    <div class="indexdiv">
      <div class="breadNav">
        <div class="nav">
          <p>健康管理 > 家属体检 > 填写预约信息</p>
        </div>
      </div>
      <div class="msg">
        <div class="top">
          <p class="p1">
            <i></i>
            <span>尊敬的客户，您好！</span>
          </p>
          <p class="p2">
            您已通过公司弹性福利平台兑换了
            <span>{{total_amount}}</span> 次家属体检服务，目前剩余 <span>{{rest_amount}}</span> 次。
          </p>
        </div>
        <div class="bottom">
          <div class="item" v-for="(item,index) in cardData" :key="index">
            <div class="tit">
              <p class="p1">
                <i></i>
                <span>{{item.batch === 'abb_f1'?'全面关爱套餐':'深度珍爱套餐'}}</span>
              </p>
              <p
                class="p2"
              >{{item.free_times === 0?'￥'+item.combo[0].sell_price:'可使用'+item.free_times+'次'}}</p>
            </div>
            <div class="content" v-if="item.batch === 'abb_f1'">
              <div>
                <p>主要针对常见全面肿瘤筛查，胃病（C14呼气实验）、肝肾疾病、高血压、甲状腺，糖尿病筛查，一般的男女性疾病筛查，适合40岁以下的职场人士体检。</p>
              </div>
              <div>
                <p>男性27项检查</p>
              </div>
              <div>
                <p>女性（不含妇科）31项检查</p>
              </div>
              <div>
                <p>女性（含妇科）34项检查</p>
              </div>
            </div>
            <div class="content" v-else>
              <div>
                <p>针对生化五项检查，心、肝、胆、肺、胃、颈椎及癌症筛查和心脑血管筛查的一款适合40岁以上人群体检的套餐。</p>
              </div>
              <div>
                <p>男性31项检查</p>
              </div>
              <div>
                <p>女性（不含妇科）34项检查</p>
              </div>
              <div>
                <p>女性（含妇科）37项检查</p>
              </div>
            </div>
            <div class="subscribe" @click="subscribe(item)">
              <p>立即预约</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import header from "../common/header.vue";
import footer from "../common/footer.vue";
export default {
  name: "indexDIV",
  data() {
    return {
      fullscreenLoading: false,
      cardData: [],
      rest_amount:'',
      total_amount:''
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer
  },
  created() {},
  mounted() {
    this.cardList();
    this.exchange_amount();
  },
  methods: {
    //   体检卡列表
    cardList() {
      let _this = this;
      _this.fullscreenLoading = false;
      axios
        .get(BASE_URL + "/exam/abb/card/", {
          params: {
            relative_type: 1
          }
        })
        .then(res => {
          _this.cardData = res.data.data;
          _this.fullscreenLoading = false;
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    },
    exchange_amount(){
      let _this = this;
      _this.fullscreenLoading = false;
      axios
        .get(BASE_URL + "/exam/abb/card/exchange_amount/")
        .then(res => {
          _this.total_amount = res.data.data.total_amount;
          _this.rest_amount = res.data.data.rest_amount;
          _this.fullscreenLoading = false;
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    },
    subscribe(item) {
      let _this = this;
      _this.$router.push({
        path: "/writeSubscribe",
        query: {
          type: _this.$route.query.type,
          batch: item.batch,
          cardId: item.id,
          cardNo: item.card_no,
          free_times: item.free_times
        }
      });
    }
  },
  computed: {
    ...mapGetters(["resturantName", "resturantId", "qhText"])
  }
};
</script>

<style scoped>
.bottom {
  width: 1180px;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
}
.bottom .item .subscribe {
  padding: 20px 0;
  display: flex;
  justify-content: center;
  border-top: 1px solid #ccc;
}
.bottom .item .subscribe p {
  width: 180px;
  height: 46px;
  background: #e94709;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  line-height: 20px;
  cursor: pointer;
}
.bottom .item .content {
  padding: 20px 30px;
}
.bottom .item .content p{
  font-size:14px;
  font-weight:400;
  color:#333;
  line-height:24px;
}
.bottom .item .tit {
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding: 14px 30px;
  display: flex;
  justify-content: space-between;
}
.bottom .item .tit .p1 {
  display: flex;
}
.bottom .item .tit .p1 i {
  display: block;
  width: 4px;
  height: 18px;
  background: #e94709;
}
.bottom .item .tit .p1 span {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 18px;
  display: block;
  margin-left: 7px;
}
.bottom .item .tit .p2 {
  font-size: 18px;
  font-weight: 600;
  color: #e94709;
  line-height: 18px;
}
.bottom .item {
  width: 48.5%;
  border: 1px solid #ccc;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.top {
  width: 1180px;
  margin: 0 auto;
  padding: 30px;
  border: 1px solid #ccc;
  margin-top: 30px;
}
.top .p2 {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 18px;
  margin-top: 18px;
}
.top .p2 span {
  color: #e94709;
}
.top .p1 {
  display: flex;
}
.top .p1 i {
  width: 4px;
  display: block;
  height: 18px;
  background: #e94709;
}
.top .p1 span {
  display: block;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 18px;
  margin-left: 7px;
}
.msg {
  width: 1180px;
  margin: 0 auto;
  margin-bottom: 50px;
}
.breadNav {
  width: 100%;
  height: 80px;
  border-bottom: 2px solid #eaeaea;
  display: flex;
  align-items: center;
}
.breadNav .nav {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.breadNav .nav p:nth-child(1) {
  font-size: 18px;

  font-weight: 600;
  color: #333;
  line-height: 20px;
}
.breadNav .nav p:nth-child(2) {
  font-size: 24px;

  font-weight: 600;
  color: #e94709;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue